import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const DatosDRCApi = () => {
    const [cargando, setCargando] = useState(false);

    const getLaboratoristas = async (params) => {
        return api
            .get("laboratorista/listar_laboratoristas_solidos", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getLaboratoristas,

        cargando,
    };
};
